import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Please identify all your current medical conditions',
    field: 'hairLossFollowup_currentMedicalConditions',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_currentMedicalConditions_ans',
      type: 'text',
      placeholder: 'Medical conditions'
    }
  },
  {
    label: 'Please list all your current medications including dosages',
    field: 'hairLossFollowup_currentMedications',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_currentMedications_ans',
      type: 'text',
      placeholder: 'Medications'
    }
  },
  {
    label: 'Please list all of your known allergies',
    field: 'hairLossFollowup_knownAllergies',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_knownAllergies_ans',
      type: 'text',
      placeholder: 'Allergies'
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'hairLossFollowup_height',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_height',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'hairLossFollowup_weight',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_weight',
      type: 'text',
      placeholder: 'Pounds'
    }
  },
  {
    label:
      'Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in?',
    field: 'hairLossFollowup_healthChanges',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'hairLossFollowup_healthChanges_no',
          value: 'No'
        },
        {
          key: 'hairLossFollowup_healthChanges_yes',
          value: 'Yes'
        }
      ]
    }
  },
  {
    field: 'hairLossFollowup_healthChanges_yes_more',
    label: 'Please tell us more about the changes in your health',
    type: 'info',
    answer: {
      type: 'text',
      rows: 3,
      name: 'hairLossFollowup_healthChanges_yes_more'
    }
  },
  {
    label: 'How are you doing on the current medication?',
    field: 'hairLossFollowup_medicationStatus',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'hairLossFollowup_medicationStatus_well',
          value: 'Well'
        },
        {
          key: 'hairLossFollowup_medicationStatus_notWell',
          value: 'Not well'
        }
      ]
    }
  },
  {
    field: 'hairLossFollowup_medicationStatus_notWell_more',
    label: 'Please tell us more about what you are experiencing',
    type: 'info',
    answer: {
      type: 'text',
      rows: 3,
      name: 'hairLossFollowup_medicationStatus_notWell_more'
    }
  },
  {
    label: 'Have you had any side effects from the current medication?',
    field: 'hairLossFollowup_medicationSideEffects',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'hairLossFollowup_medicationSideEffects_no',
          value: 'No'
        },
        {
          key: 'hairLossFollowup_medicationSideEffects_yes',
          value: 'Yes'
        }
      ]
    }
  },
  {
    field: 'hairLossFollowup_medicationSideEffects_yes_ans',
    label: 'Please tell us more about the side effects you are experiencing',
    type: 'info',
    answer: {
      type: 'text',
      rows: 3,
      name: 'hairLossFollowup_medicationSideEffects_yes_ans'
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'hairLossFollowup_otherInformationOrQuestions',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_otherInformationOrQuestions',
      type: 'text'
    }
  },
  {
    label: 'Consent Form for Hair Loss Treatment',
    educationalSlide: `
    Consent:

    Purpose of Treatment
    To address hair loss in both men and women through various medical interventions aimed at slowing hair loss, promoting new hair growth, and improving hair density and appearance.

    Potential Benefits
    - Slowing down the progression of hair loss
    - Stimulating new hair growth 
    - Enhancing the thickness and appearance of existing hair
    - Improving self-esteem and quality of life

    Contraindications
    Certain treatments may not be suitable for individuals with:
    - Specific medical conditions (e.g., liver disease, kidney disease, hormonal imbalances)
    - Allergies to medications or their components
    - Pregnancy or breastfeeding  
    - Scalp conditions such as dermatitis or psoriasis

    Potential Risks and Side Effects
    - Scalp irritation, itching, or dryness
    - Hormonal changes
    - Unwanted hair growth in unintended areas
    - Electrolyte imbalances 
    - Mood changes or depression
    - Allergic reactions
    - Changes in blood pressure or heart rate
    - Decreased libido and/or erectile dysfunction in men

    Monitoring and Follow-up
    Regular monitoring is recommended to assess effectiveness and detect any side effects. This may include physical examinations and laboratory tests as deemed necessary by your healthcare provider. Inform your provider of any adverse reactions or concerns.

    Alternative Treatments
    - Hair transplant surgery
    - Low-level laser therapy
    - Platelet-rich plasma (PRP) therapy
    - Lifestyle adjustments and acceptance of hair loss

    Consent for Other Treatments
    By signing this consent form, you agree to the use of medications or treatments as recommended by your healthcare provider for the management of hair loss. All treatments, including those not specifically mentioned above, will be discussed with you, including their potential benefits and risks.


    Patient Responsibilities
    - Use treatments exactly as prescribed
    - Report any side effects promptly
    - Keep all follow-up appointments
    - Inform your provider of any changes in your health status or medications

    Consent
    By selecting below, you understand the potential risks and benefits of using enclomiphene and the off-label nature of this treatment. You agree to follow the monitoring plan and inform your healthcare provider of any side effects or concerns.
    `,
    field: 'hairLossFollowup_consent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'hairLossFollowup_consent_non_consent',
          class: 'option-decline',
          value:
            'I have read and understand the information and I DO NOT wish to proceed'
        },
        {
          key: 'hairLossFollowup_consent_consent',
          class: 'option-consent',
          value:
            'I have read and understand the information and wish to proceed'
        }
      ]
    }
  },
  {
    field: 'hairLossFollowup_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'hairLossFollowup_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    blockQuestionFlow: true,
    educationalSlide: '',
    type: 'info',
    isLast: true,
    answer: {}
  }
];

export default questionsModels;
// // 3211#MENSHAIRLOSSFOLLOWUP@1737647170982
// const data = {
//   formObj: {
//     consentsSigned: true,
//     firstName: 'Ibrahim',
//     lastName: 'M',
//     dob: '12/12/1999',
//     phone: '6572392082',
//     email: 'ibrahim@appgen.ca',
//     sex: 'Male',
//     address: 'asd asd',
//     city: 'asd',
//     state: 'NY',
//     zip: '10004',
//     selfReportedMeds: 'asd; asd',
//     allergies: 'Sulfa drugs',
//     medicalConditions: 'Heart disease; Irregular heartbeat',
//     patientPreference: [
//       {
//         name: 'Finasteride 1mg',
//         strength: '0',
//         quantity: '1',
//         refills: '0',
//         medId: 'YbS4W45zs7EImDPJ4Lbs5DVWhUqMxxX5'
//       }
//     ],
//     Q1: 'What is your height in feet and inches?',
//     A1: '6 ft 2',
//     Q2: 'What is your weight in pounds?',
//     A2: '123',
//     Q3: 'Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in? POSSIBLE ANSWERS: No; Yes',
//     A3: 'Yes',
//     Q4: 'Please tell us more about the changes in your health',
//     A4: '123',
//     Q5: 'How are you doing on the current medication? POSSIBLE ANSWERS: Well; Not well',
//     A5: 'Not well',
//     Q6: 'Please tell us more about what you are experiencing',
//     A6: '123',
//     Q7: 'Have you had any side effects from the current medication? POSSIBLE ANSWERS: No; Yes',
//     A7: 'Yes',
//     Q8: 'Please tell us more about the side effects you are experiencing',
//     A8: '123',
//     Q9: 'What other information or questions do you have for the doctor?',
//     A9: '123',
//     Q10: 'Consent Form for Hair Loss Treatment\n    Consent Form for Hair Loss Treatment\n\n    Purpose of Treatment\n    Finasteride: An oral medication that inhibits the conversion of testosterone to dihydrotestosterone (DHT), a hormone linked to hair loss. It helps slow hair loss and may promote regrowth.\n    Minoxidil: A topical solution that stimulates hair follicles to promote hair growth. It increases blood flow to the scalp.\n    GUK-Cu: A copper peptide complex believed to stimulate hair growth by enhancing blood flow and supporting scalp health.\n\n    Potential Benefits\n    These treatments aim to slow hair loss, promote new hair growth, and improve hair density and appearance.\n\n    Contraindications\n    Finasteride \n     - Individuals with liver disease        \n     - Those with a history of prostate cancer        \n     - Anyone allergic to finasteride or its components        \n     - Women who are or may become pregnant should not handle finasteride tablets    \n\n    Minoxidil        \n     - Individuals with scalp conditions like dermatitis or psoriasis        \n     - Those allergic to minoxidil or its components    \n    \n    GUK-Cu \n     - Should not be used by individuals allergic to copper peptides or any of its components    \n\n    Potential Risks and Side Effects\n    \n    Finasteride    \n     - Sexual dysfunction (decreased libido, erectile dysfunction)        \n     - Breast tenderness or enlargement        \n     - Depression or mood changes        \n     - Allergic reactions        \n     - Possible effect on PSA levels used in prostate cancer screening    \n    Minoxidil\n     - Scalp irritation, itching, or dryness        \n     - Unwanted facial or body hair growth        \n     - Changes in blood pressure or heart rate (rare)    \n    GUK-Cu\n     - Scalp irritation        \n     - Allergic reactions    \n\n    Monitoring and Follow-up\n    Regular monitoring is recommended to assess effectiveness and detect any side effects. Inform your healthcare provider of any adverse reactions or concerns.\n    Alternative Treatments\n     - Hair transplant surgery        \n     - Low-level laser therapy        \n     - Platelet-rich plasma (PRP) therapy        \n     - Lifestyle changes and acceptance of hair loss    \n\n    Patient Responsibilities   \n     - Use medications exactly as prescribed        \n     - Report any side effects promptly        \n     - Keep all follow-up appointments        \n     - Inform your provider of any changes in your health status or medications        \n\n    \n    Consent\n    By agreeing below, you acknowledge that you have read and understood the information provided in this consent form. You agree to proceed with treatment under the conditions outlined above.\n     POSSIBLE ANSWERS: I have read and understand the information and wish to proceed; I have read and understand the information and I DO NOT wish to proceed',
//     A10: 'I have read and understand the information and wish to proceed'
//   },
//   pharmacyId: '29992',
//   masterId: '3211#MENSHAIRLOSSFOLLOWUP@1737647170982',
//   company: 'carePortalsMandos',
//   visitType: 'hairloss'
// };

// 3211#MENSHAIRLOSSFOLLOWUP@1737648074063
// + Updated contract
// {
//   "formObj": {
//       "consentsSigned": true,
//       "firstName": "Ibrahim",
//       "lastName": "M",
//       "dob": "12/12/1999",
//       "phone": "6572392082",
//       "email": "ibrahim@appgen.ca",
//       "sex": "Male",
//       "address": "asd asd",
//       "city": "asd",
//       "state": "NY",
//       "zip": "10004",
//       "selfReportedMeds": "asd; asd",
//       "allergies": "Sulfa drugs",
//       "medicalConditions": "Heart disease; Irregular heartbeat",
//       "patientPreference": [
//           {
//               "name": "Finasteride 1mg",
//               "strength": "0",
//               "quantity": "1",
//               "refills": "0",
//               "medId": "YbS4W45zs7EImDPJ4Lbs5DVWhUqMxxX5"
//           }
//       ],
//       "Q1": "What is your height in feet and inches?",
//       "A1": "6 ft 2",
//       "Q2": "What is your weight in pounds?",
//       "A2": "123",
//       "Q3": "Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in? POSSIBLE ANSWERS: No; Yes",
//       "A3": "Yes",
//       "Q4": "Please tell us more about the changes in your health",
//       "A4": "123",
//       "Q5": "How are you doing on the current medication? POSSIBLE ANSWERS: Well; Not well",
//       "A5": "Not well",
//       "Q6": "Please tell us more about what you are experiencing",
//       "A6": "123",
//       "Q7": "Have you had any side effects from the current medication? POSSIBLE ANSWERS: No; Yes",
//       "A7": "Yes",
//       "Q8": "Please tell us more about the side effects you are experiencing",
//       "A8": "123",
//       "Q9": "What other information or questions do you have for the doctor?",
//       "A9": "123",
//       "Q10": "Consent Form for Hair Loss Treatment\n    Consent Form for Hair Loss Treatment\n\n    Purpose of Treatment\n    To address hair loss in both men and women through various medical interventions aimed at slowing hair loss, promoting new hair growth, and improving hair density and appearance.\n\n    Potential Benefits\n    - Slowing down the progression of hair loss\n    - Stimulating new hair growth \n    - Enhancing the thickness and appearance of existing hair\n    - Improving self-esteem and quality of life\n\n    Contraindications\n    Certain treatments may not be suitable for individuals with:\n    - Specific medical conditions (e.g., liver disease, kidney disease, hormonal imbalances)\n    - Allergies to medications or their components\n    - Pregnancy or breastfeeding  \n    - Scalp conditions such as dermatitis or psoriasis\n\n    Potential Risks and Side Effects\n    - Scalp irritation, itching, or dryness\n    - Hormonal changes\n    - Unwanted hair growth in unintended areas\n    - Electrolyte imbalances \n    - Mood changes or depression\n    - Allergic reactions\n    - Changes in blood pressure or heart rate\n    - Decreased libido and/or erectile dysfunction in men\n\n    Monitoring and Follow-up\n    Regular monitoring is recommended to assess effectiveness and detect any side effects. This may include physical examinations and laboratory tests as deemed necessary by your healthcare provider. Inform your provider of any adverse reactions or concerns.\n\n    Alternative Treatments\n    - Hair transplant surgery\n    - Low-level laser therapy\n    - Platelet-rich plasma (PRP) therapy\n    - Lifestyle adjustments and acceptance of hair loss\n\n    Patient Responsibilities\n    - Use treatments exactly as prescribed\n    - Report any side effects promptly\n    - Keep all follow-up appointments\n    - Inform your provider of any changes in your health status or medications\n\n    Consent\n    By signing this consent form, you agree to use medications or treatments as recommended by your healthcare provider for hair loss management. All treatments will be discussed with you, including potential benefits and risks.\n     POSSIBLE ANSWERS: I have read and understand the information and wish to proceed; I have read and understand the information and I DO NOT wish to proceed",
//       "A10": "I have read and understand the information and wish to proceed"
//   },
//   "pharmacyId": "29992",
//   "masterId": "3211#MENSHAIRLOSSFOLLOWUP@1737648074063",
//   "company": "carePortalsMandos",
//   "visitType": "hairloss"
// }
